import {getDataWithPromise, Globals, handleAjaxError} from "./BaseDataFns";

export const doRegister = ( newpass, token, onComplete ) =>
{
    const url = Globals.APIFolder + '/users/register'

    const data = {
        inpPassword: newpass,
        token: token
    } ;

    getDataWithPromise ( url, 'POST', data )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const doPasswordReset = ( username, onComplete ) =>
{
    const url = Globals.APIFolder + '/users/forgotPassword?system=new'

    const data = {
        username: username,
    } ;

    getDataWithPromise ( url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const setAcceptableUsageAgreed = ( onComplete ) =>
{
    const url = Globals.APIFolder + '/users/acceptable_usage' ;

    getDataWithPromise ( url, 'POST', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}
